import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=bf5b7a2e"
import script from "./ButtonSecondary.vue?vue&type=script&lang=ts"
export * from "./ButtonSecondary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports